// extracted by mini-css-extract-plugin
export var centered = "_h-6";
export var flexible = "_h-5";
export var footer = "_h-k";
export var footerBorder = "_h-l";
export var header = "_h-c";
export var headerBorder = "_h-d";
export var headerDefault = "_h-g";
export var headerMedium = "_h-h";
export var headerPadding = "_h-e";
export var iconAndTitle = "_h-f";
export var large = "_h-4";
export var largePadding = "_h-a";
export var medium = "_h-3";
export var mediumPadding = "_h-9";
export var modal = "_h-0";
export var modalContainer = "_h-b";
export var noPadding = "_h-7";
export var skinny = "_h-1";
export var small = "_h-2";
export var smallPadding = "_h-8";
export var subtitle = "_h-j";
export var title = "_h-i";